"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _Button = require("./Button.styled");
var _excluded = ["ariaLabel", "size", "color", "onClick", "disabled", "children", "icon"];
var Button = exports.Button = function Button(props) {
  var ariaLabel = props.ariaLabel,
    size = props.size,
    color = props.color,
    onClick = props.onClick,
    disabled = props.disabled,
    children = props.children,
    icon = props.icon,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  // if no children, icon will be displayed a bit bigger
  return /*#__PURE__*/_react["default"].createElement(_Button.StyledButton, (0, _extends2["default"])({
    "aria-label": ariaLabel,
    size: size,
    color: color,
    iconOnly: !children,
    onClick: onClick,
    disabled: disabled
  }, rest), icon && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon
  }), children);
};
Button.defaultProps = {
  color: 'primary',
  disabled: false,
  variant: 'contained',
  size: 'medium'
};
Button.propTypes = {
  color: _propTypes["default"].oneOf(['primary', 'success', 'danger', 'destructive', 'secondary', 'light', 'outline']),
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  variant: _propTypes["default"].oneOf(['contained', 'outlined', 'ghost', 'link']),
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  icon: _propTypes["default"].element
};
var _default = exports["default"] = Button;